module.exports = __webpack_public_path__ + "assets/img/wuhan.67e27d87.png";